import { useMediaQuery } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import React from 'react';

import illustration from './illustration.png';

const AvatarImg = () => {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('md'));
  const size = isMobile ? 190 : 265;

  return (
    <Box display="flex" justifyContent="center" mb={2} mt={2}>
      <Avatar alt="Profile 1" src={illustration} sx={{ width: size, height: size }} />
    </Box>
  );
};

export default AvatarImg;
